import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {SharedDataService} from "../../../services/shared-data.service";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {ListItem} from "../../../objects/listItem";
import {User} from "../../../objects/user";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DeleteConfirmationComponent} from "../../delete-confirmation/delete-confirmation.component";
import {ConfirmationDialogComponent} from "../../confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'app-user-referrals-popup',
  templateUrl: './user-referrals-popup.component.html',
  styleUrls: ['./user-referrals-popup.component.css']
})
export class UserReferralsPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();

  profile: User;
  pickList: ListItem[] = [];
  pickItemsLoading: boolean;
  referrals: ListItem[];
  state: string = 'default';
  errMsg: string = '';

  constructor(public sharedDataService: SharedDataService,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog) {
  }

  protected itemID: number
  ngOnInit(): void {
    this.itemID = this.payload['item']['itemFullData']['id'];
    this.loadUserReferrals();
  }

  protected loadUserReferrals() {
    this.state = 'loading';
    this.application.apiService.getProfileEvents(environment['gid'], this.itemID, environment['g_hash'], '')
      .subscribe(
        data => this.handleItems(data),
        error => this.handleItemsError(error))
  }

  private proFileEventsData:object;
  private handleItems(data) {
    this.proFileEventsData = data;
    this.profile = this.proFileEventsData['profile'] as User;
    this.referrals = this.application.apiService.extractProfilesData(this.profile.referrals,'my_referral');
    console.log('this.profile.referrals',this.profile.referrals,this.referrals);
    this.state = 'default'
  }

  private handleItemsError(error) {
    this.pickItemsLoading = false;
    this.state = 'error';
    this.errMsg = error.errMsg;
  }

  public onNoClick(): void {
    this.close.emit()
  }

  public pickReferral(): void {
    this.pickList = [];
    this.pickItemsLoading = true;
    this.application.apiService.getClients('', AppComponent.user.magic_key)
      .subscribe(
        items => this.gotClients(items),
        error => this.handleItemsError(error))
  }
  public gotClients(items): void {
    items.map(item => {
      if(item['itemFullData']['id'] == this.profile.id) { //self skip
        return;
      }
      if(this.referrals.filter(existing => item['itemFullData']['id'] == existing['itemFullData']['id']).length) {
        return;
      }
      this.pickList.push(item);
    });
    this.pickItemsLoading = false;
    this.pickReferralPopup();
  }
  public pickReferralPopup(): void {
    let payloadUsers = this.pickList;
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
      height: 'auto',
      data: {
        application: this.application,
        state: 'user-pick',
        payload: {users: payloadUsers},
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload) {
          //console.log('dialogPayload',dialogPayload)
          this.referrals.push(dialogPayload['user'])
          this.referrals = [...this.referrals]
          this.pickItemsLoading = true;
          this.application.apiService
            .saveUserReferral(environment['gid'],environment['g_hash'],
              this.profile.id,dialogPayload['user']['itemFullData']['id'],'save_referral')
            .subscribe(
              data => this.referralSaved(data),
              error => this.handleItemsError(error))
        }
      })
  }

  public referralSaved(data) {
    this.pickItemsLoading = false;
    let notification = new FS3Notification();
    notification.type = 'success';
    notification.text = 'Saved!';
    this.application.sharedDataService.pushNotification(notification);
    this.loadUserReferrals()
  }

  public deleteReferral(item:ListItem) {
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: AppComponent.getLabel('delete_confirmation_popup_title'),
        message: AppComponent.getLabel('delete_confirmation_popup_description'),
        cancelLabel: AppComponent.getLabel('close'),
        actionLabel: AppComponent.getLabel('confirm'),
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        if (result && result.isConfirmed) {
          dialogRef.close()
          this.pickItemsLoading = true;
          this.application.apiService
            .saveUserReferral(environment['gid'],environment['g_hash'],
              this.profile.id,item['itemFullData']['id'],'delete_referral')
            .subscribe(
              data => this.referralSaved(data),
              error => this.handleItemsError(error))
        }
      })
  }
}
